import './src/styles/global.scss';
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider
    useEnterprise
    reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
    scriptProps={{ async: true, defer: true, appendTo: 'body' }}
  >
    {element}
  </GoogleReCaptchaProvider>
);

export const onInitialClientRender = () => {
  window.dataLayer = window.dataLayer || [];

  const statisticalConsent = document.cookie.includes('consent-statistical=true');
  const marketingConsent = document.cookie.includes('consent-marketing=true');

  if (statisticalConsent || marketingConsent) {
    window.dataLayer.push([
      'consent',
      'update',
      {
        analytics_storage: statisticalConsent ? 'granted' : 'denied',
        ad_storage: marketingConsent ? 'granted' : 'denied',
        ad_user_data: marketingConsent ? 'granted' : 'denied',
        ad_personalization: marketingConsent ? 'granted' : 'denied',
      },
    ]);
  }
};
